<app-scroll-view-with-bottom-bar>
  @if (this.formData) {
    <div class="row">
      <div
        class="col-lg-12 mt-3"
        style="margin-bottom: 60px"
      >
        <dx-validation-group #damageReportVG>
          <div class="dx-field">
            <div class="dx-field-label">{{ 'report.firstname' | translate }}</div>
            <div class="dx-field-value">
              @if (formData.firstname) {
                <dx-text-box [(value)]="formData.firstname">
                  <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">{{ 'report.lastname' | translate }}</div>
            <div class="dx-field-value">
              @if (formData.lastname) {
                <dx-text-box [(value)]="formData.lastname">
                  <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">{{ 'report.location' | translate }}</div>
            <div class="dx-field-value">
              <dx-select-box
                [text]="'report.location' | translate"
                [items]="this.availableLocations"
                valueExpr="value"
                displayExpr="value"
                [(value)]="formData.location"
                fieldTemplate="field"
              >
                <div *dxTemplate="let data of 'field'">
                  <div class="custom-item">
                    <dx-text-box
                      [value]="translateService.instant('report.' + data.value)"
                      [readOnly]="true"
                    ></dx-text-box>
                  </div>
                </div>
                <div *dxTemplate="let item of 'item'">
                  {{ 'report.' + item.value | translate }}
                </div>
              </dx-select-box>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">{{ 'report.locationExtension' | translate }}</div>
            <div class="dx-field-value">
              @if (formData.locationExtension) {
                <dx-text-box [(value)]="formData.locationExtension"></dx-text-box>
              }
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">{{ 'report.description' | translate }}</div>
            <div class="dx-field-value">
              @if (formData.description) {
                <dx-text-area
                  [(value)]="formData.description"
                  height="150"
                ></dx-text-area>
              }
            </div>
          </div>
        </dx-validation-group>
      </div>
    </div>
  }
  @if (this.formData) {
    <ng-container class="bottom-bar">
      <dx-button
        class="small"
        [type]="'normal'"
        [stylingMode]="'text'"
        (onClick)="close()"
        >{{ 'general.buttons.cancel' | translate }}
      </dx-button>
      <app-button (buttonClick)="send()" label="Senden"></app-button>
    </ng-container>
  }
</app-scroll-view-with-bottom-bar>
